var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ModalBase,{attrs:{"name":_vm.name,"title":"Crear categoría"},on:{"close":function($event){return _vm.$emit('close')}}},[_c(_setup.CategoriaForm,{attrs:{"initial-data":null,"submit-label":"Guardar","loading":_vm.loading},on:{"submit":_setup.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }